import { Controller } from 'stimulus'
import { debounce } from 'lodash'

export default class PatientSearchController extends Controller {
  static targets = []

  search = debounce(async (evt) => {
    const res = await fetch(`/patients?search=${evt.target.value}`)
    const response = await res.text()

    const parser = new window.DOMParser(response)
    const doc = parser.parseFromString(response, 'text/html')
    const table = doc.querySelector('.patients-table')

    document.querySelector('.patients-table').innerHTML = table.innerHTML
  }, 300)
}
